import { Badge } from "design-system/atoms/Badge"
import { cn } from "design-system/utils"
import { isNil } from "lopermut"

type Props = {
  nps: number | undefined | null
  className?: string
}

export const NPSBadge = ({ nps, className }: Props) => {
  if (isNil(nps)) return <span className="text-muted-foreground">{"-"}</span>

  return (
    <Badge
      variant="outline"
      className={cn(
        "border-negative text-negative",
        nps > 6 && "text-muted-foreground/50 border-muted-foreground/50",
        nps > 8 && "text-positive border-positive",
        className,
      )}
    >
      {nps}
    </Badge>
  )
}
